<template>
    <v-progress-linear
        v-if="loading"
        color="primary"
        indeterminate
        rounded
        height="12"
    ></v-progress-linear>
    <hotel-form
        v-else
        :hotel="hotel"
        :dialog-data.sync="responseDialog"
        @finish="finish"
    />
</template>

<script>
import HotelForm from "../../components/Hotel/HotelForm.vue";
export default {
    name: "EditHotel",
    components: {
        HotelForm
    },
    data() {
        return {
            hotel: null,
            loading: true,
            responseDialog: {
                model: false,
                loading: false,
                dialogTitle: '',
                dialogMessage: '',
                dialogType: ''
            },
        }
    },
    methods: {
        finish: function (data) {
            axios.put("/api/hotel/" + this.hotel.id, data, { validateStatus: () => true })
                .then(res => {
                    if (res.data.success) {
                        this.responseDialog.dialogTitle = 'Muito Bom';
                        this.responseDialog.dialogMessage = 'Hotel Atualizado com Sucesso!';
                        this.responseDialog.dialogType = 'success';
                    } else {
                        if (res?.data?.fields) {
                            const allErrors = Object.values(res.data.fields).flat();
                            this.responseDialog.dialogTitle = res?.data?.message ?? 'Ops...';
                            this.responseDialog.dialogMessage = allErrors.join('<br>');
                            this.responseDialog.dialogType = 'error';
                        }
                        else {
                            this.responseDialog.dialogTitle = 'Ops...';
                            this.responseDialog.dialogMessage = res?.data?.message ?? 'Aconteceu algum problema...';
                            this.responseDialog.dialogType = 'error';
                        }
                    }
                }).catch((error) => {
                    this.responseDialog.dialogTitle = 'Ops...';
                    if ( error?.response?.data?.fields) {
                        const allErrors = Object.values(error?.response?.data?.fields).flat();
                        this.responseDialog.dialogTitle = error?.response?.data?.message ?? 'Ops...';
                        this.responseDialog.dialogMessage = allErrors.join('<br>');
                    } else {
                        this.responseDialog.dialogMessage = 'Aconteceu algum problema...';
                    }
                    this.responseDialog.dialogType = 'error';
                }).finally(() => {
                    this.responseDialog.model = true;
                });
        }
    },
    mounted(){
        axios.get(`/api/hotel/${this.$route.params.id}`)
            .then(res => {
                this.hotel = res.data
                this.loading = false
            })
    }
}
</script>

<style scoped>

</style>
